const SET_DATA = (state, payload) => {
  const { countPerPage, result } = payload;

  state.countPerPage = countPerPage;
  state.lastDataChunk = result;
  state.widgets.push(...result);
};

const RESET_DATA = (state) => {
  state.countPerPage = 0;
  state.lastDataChunk = [];
  state.page = 1;
  state.widgets = [];
};

const CHANGE_STATUS = (state, payload) => {
  const { widgets } = state;

  const widget = widgets.find(widget => widget.code === payload.code);
  widget.status = payload.status;
};

const REMOVE_WIDGET_BY_CODE = (state, code) => {
  const { widgets } = state;
  const widgetIdx = widgets.findIndex(widget => widget.code === code);

  widgets.splice(widgetIdx, 1);
};

const INCREMENT_PAGE = (state) => state.page++;

export default {
  SET_DATA,
  RESET_DATA,
  CHANGE_STATUS,
  REMOVE_WIDGET_BY_CODE,
  INCREMENT_PAGE,
};
